<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14EecY1/tc-custom/9781426855443.jpg?1740451937742" alt="This image is the cover for the book Hitched!, Whitehorse, Montana: Winchester Ranch Reloaded"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hitched!, Whitehorse, Montana: Winchester Ranch Reloaded
      </h1>
      <p class="bookDescription body article font2">
        <b>A rancher offers a woman in jeopardy a pretend marriage and his protection in this romantic suspense from a <i>New York Times</i>–bestselling author.</b><br/><br/>Following a trail of secrets back to his family ranch, Jack Winchester needed a cover to solve a decades-old mystery. And Josey Smith offered him the perfect one—if she would agree to pose as his wife for a week. The gorgeous redhead was up to her neck in trouble, and Jack would protect his pretend bride no matter what—real wedding vows or not.<br/><br/>On the run from a killer, Josey had no choice but to accept Jack’s proposal. She no longer trusted herself to tell the good guys from the bad, but the handsome, blue-eyed cowboy made her feel safe. Yet it soon became apparent that the sparks that flew between them were anything but fake, and the danger they faced was all too real. . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        B.J. Daniels
      </h2>
      
      <p class="authorDescription body article">New York Times and USA Today bestselling author B.J. Daniels lives in Montana with her husband, Parker, and two springer spaniels. When not writing, she quilts, boats and always has a book or two to read. Contact her at <a href="http://www.bjdaniels.com/">www.bjdaniels.com</a>, on Facebook at B.J. Daniels or through her reader group the B.J. Daniels' Big Sky Darlings, and on twitter at bjdanielsauthor.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b3984840